import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Icon } from '../../index.js';

/**
 * An info-field component
 * @param {{
 *   className?: string,
 *   icon?: string|boolean,
 *   success?: boolean,
 *   info?: boolean,
 *   warning?: boolean,
 *   error?: boolean,
 *   message?: string,
 *   onClose?: function
 * }} props
 * @return {JSX.Element}
 * @constructor
 */
export const InfoField = (props) => {
  const {
    children,
    className,
    icon = true,
    iconName,
    success = false,
    info = false,
    warning = false,
    error = false,
    onClose,
  } = props;

  const [animateClasses, setAnimateClasses] = useState('opacity-100');

  /**
   * Get corresponding icon reference
   * @returns {string|undefined}
   */
  const _icon = () => {
    if (!icon) {
      return undefined;
    }

    if (iconName) {
      return iconName;
    }

    if (success) {
      return 'form-success';
    }
    if (error) {
      return 'form-error';
    }
    if (info) {
      return 'form-notification';
    }
    if (warning) {
      return 'form-warning';
    }
    return 'form-help';
  };

  const colorClasses = () => {
    if (success) {
      return 'bg-green-light text-cmblack';
    }
    if (error) {
      return 'bg-red-light text-red-dark';
    }
    if (info) {
      return 'bg-blue-light text-cmblack';
    }
    if (warning) {
      return 'bg-orange-light text-cmblack';
    }
    return 'bg-beige-light text-cmblack';
  };

  const handleClick = () => {
    setAnimateClasses('opacity-0 h-0');
    if (onClose) {
      onClose();
    }
  };

  return (
    <div
      className={twMerge(
        'flex w-full text-md bg-beige-light text-cmblack rounded transition-all duration-500 ease-in-out',
        colorClasses(),
        animateClasses,
        className,
      )}
    >
      {icon && (
        <Icon name={_icon()} className="flex-none w-5 h-5 mt-1.5 ml-1.5"/>
      )}
      <div className={twMerge('p-1.5', onClose ? 'w-11/12' : '')}>{children}</div>
      {onClose && (
        <Icon
          name="close"
          className="flex-none w-5 h-5 ml-auto mt-1.5 mr-1.5 cursor-pointer"
          onClick={handleClick}
        />
      )}
    </div>
  );
};
